/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AddressAddressTag;
(function (AddressAddressTag) {
    AddressAddressTag["UNTAGGED"] = "UNTAGGED";
    AddressAddressTag["HOME"] = "HOME";
    AddressAddressTag["WORK"] = "WORK";
    AddressAddressTag["BILLING"] = "BILLING";
    AddressAddressTag["SHIPPING"] = "SHIPPING";
    AddressAddressTag["OTHER"] = "OTHER";
})(AddressAddressTag = exports.AddressAddressTag || (exports.AddressAddressTag = {}));
var CType;
(function (CType) {
    CType["STRING"] = "STRING";
    CType["CORD"] = "CORD";
    CType["STRING_PIECE"] = "STRING_PIECE";
})(CType = exports.CType || (exports.CType = {}));
var ContactActivityType;
(function (ContactActivityType) {
    ContactActivityType["GENERAL"] = "GENERAL";
    ContactActivityType["CONTACT_CREATED"] = "CONTACT_CREATED";
    ContactActivityType["MEMBER_LOGIN"] = "MEMBER_LOGIN";
    ContactActivityType["MEMBER_REGISTER"] = "MEMBER_REGISTER";
    ContactActivityType["MEMBER_STATUS_CHANGED"] = "MEMBER_STATUS_CHANGED";
    ContactActivityType["FORM_SUBMITTED"] = "FORM_SUBMITTED";
    ContactActivityType["INBOX_FORM_SUBMITTED"] = "INBOX_FORM_SUBMITTED";
    ContactActivityType["INBOX_PAYMENT_REQUEST_PAID"] = "INBOX_PAYMENT_REQUEST_PAID";
    ContactActivityType["INBOX_MESSAGE_TO_CUSTOMER"] = "INBOX_MESSAGE_TO_CUSTOMER";
    ContactActivityType["INBOX_MESSAGE_FROM_CUSTOMER"] = "INBOX_MESSAGE_FROM_CUSTOMER";
    ContactActivityType["NEWSLETTER_SUBSCRIPTION_FORM_SUBMITTED"] = "NEWSLETTER_SUBSCRIPTION_FORM_SUBMITTED";
    ContactActivityType["NEWSLETTER_SUBSCRIPTION_UNSUBSCRIBE"] = "NEWSLETTER_SUBSCRIPTION_UNSUBSCRIBE";
    ContactActivityType["ECOM_PURCHASE"] = "ECOM_PURCHASE";
    ContactActivityType["ECOM_CART_ABANDON"] = "ECOM_CART_ABANDON";
    ContactActivityType["ECOM_CHECKOUT_BUYER"] = "ECOM_CHECKOUT_BUYER";
    ContactActivityType["BOOKINGS_APPOINTMENT"] = "BOOKINGS_APPOINTMENT";
    ContactActivityType["HOTELS_RESERVATION"] = "HOTELS_RESERVATION";
    ContactActivityType["HOTELS_PURCHASE"] = "HOTELS_PURCHASE";
    ContactActivityType["HOTELS_CONFIRMATION"] = "HOTELS_CONFIRMATION";
    ContactActivityType["HOTELS_CANCEL"] = "HOTELS_CANCEL";
    ContactActivityType["VIDEO_PURCHASE"] = "VIDEO_PURCHASE";
    ContactActivityType["VIDEO_RENT"] = "VIDEO_RENT";
    ContactActivityType["CASHIER_BUTTON_PURCHASE"] = "CASHIER_BUTTON_PURCHASE";
    ContactActivityType["ARENA_NEW_LEAD"] = "ARENA_NEW_LEAD";
    ContactActivityType["EVENTS_RSVP"] = "EVENTS_RSVP";
    ContactActivityType["INVOICE_PAY"] = "INVOICE_PAY";
    ContactActivityType["INVOICE_OVERDUE"] = "INVOICE_OVERDUE";
    ContactActivityType["PRICE_QUOTE_ACCEPT"] = "PRICE_QUOTE_ACCEPT";
    ContactActivityType["PRICE_QUOTE_EXPIRE"] = "PRICE_QUOTE_EXPIRE";
    ContactActivityType["RESTAURANTS_ORDER"] = "RESTAURANTS_ORDER";
    ContactActivityType["RESTAURANTS_RESERVATION"] = "RESTAURANTS_RESERVATION";
    ContactActivityType["SHOUTOUT_OPEN"] = "SHOUTOUT_OPEN";
    ContactActivityType["SHOUTOUT_CLICK"] = "SHOUTOUT_CLICK";
    ContactActivityType["CONTACT_MERGED"] = "CONTACT_MERGED";
})(ContactActivityType = exports.ContactActivityType || (exports.ContactActivityType = {}));
var ContactAddressAddressTag;
(function (ContactAddressAddressTag) {
    ContactAddressAddressTag["UNTAGGED"] = "UNTAGGED";
    ContactAddressAddressTag["HOME"] = "HOME";
    ContactAddressAddressTag["WORK"] = "WORK";
    ContactAddressAddressTag["BILLING"] = "BILLING";
    ContactAddressAddressTag["SHIPPING"] = "SHIPPING";
})(ContactAddressAddressTag = exports.ContactAddressAddressTag || (exports.ContactAddressAddressTag = {}));
var ContactEmailEmailTag;
(function (ContactEmailEmailTag) {
    ContactEmailEmailTag["UNTAGGED"] = "UNTAGGED";
    ContactEmailEmailTag["MAIN"] = "MAIN";
    ContactEmailEmailTag["HOME"] = "HOME";
    ContactEmailEmailTag["WORK"] = "WORK";
})(ContactEmailEmailTag = exports.ContactEmailEmailTag || (exports.ContactEmailEmailTag = {}));
var ContactFieldSet;
(function (ContactFieldSet) {
    ContactFieldSet["BASIC"] = "BASIC";
    ContactFieldSet["COMMUNICATION_DETAILS"] = "COMMUNICATION_DETAILS";
    ContactFieldSet["EXTENDED"] = "EXTENDED";
    ContactFieldSet["FULL"] = "FULL";
})(ContactFieldSet = exports.ContactFieldSet || (exports.ContactFieldSet = {}));
var ContactPhonePhoneTag;
(function (ContactPhonePhoneTag) {
    ContactPhonePhoneTag["UNTAGGED"] = "UNTAGGED";
    ContactPhonePhoneTag["MAIN"] = "MAIN";
    ContactPhonePhoneTag["HOME"] = "HOME";
    ContactPhonePhoneTag["MOBILE"] = "MOBILE";
    ContactPhonePhoneTag["WORK"] = "WORK";
    ContactPhonePhoneTag["FAX"] = "FAX";
})(ContactPhonePhoneTag = exports.ContactPhonePhoneTag || (exports.ContactPhonePhoneTag = {}));
var ContactSourceType;
(function (ContactSourceType) {
    ContactSourceType["OTHER"] = "OTHER";
    ContactSourceType["ADMIN"] = "ADMIN";
    ContactSourceType["WIX_APP"] = "WIX_APP";
    ContactSourceType["IMPORT"] = "IMPORT";
    ContactSourceType["THIRD_PARTY"] = "THIRD_PARTY";
    ContactSourceType["WIX_BOOKINGS"] = "WIX_BOOKINGS";
    ContactSourceType["WIX_CHAT"] = "WIX_CHAT";
    ContactSourceType["WIX_EMAIL_MARKETING"] = "WIX_EMAIL_MARKETING";
    ContactSourceType["WIX_EVENTS"] = "WIX_EVENTS";
    ContactSourceType["WIX_FORMS"] = "WIX_FORMS";
    ContactSourceType["WIX_GROUPS"] = "WIX_GROUPS";
    ContactSourceType["WIX_HOTELS"] = "WIX_HOTELS";
    ContactSourceType["WIX_MARKET_PLACE"] = "WIX_MARKET_PLACE";
    ContactSourceType["WIX_MUSIC"] = "WIX_MUSIC";
    ContactSourceType["WIX_RESTAURANTS"] = "WIX_RESTAURANTS";
    ContactSourceType["WIX_SITE_MEMBERS"] = "WIX_SITE_MEMBERS";
    ContactSourceType["WIX_STORES"] = "WIX_STORES";
})(ContactSourceType = exports.ContactSourceType || (exports.ContactSourceType = {}));
var ContactType;
(function (ContactType) {
    ContactType["CONTACT"] = "CONTACT";
    ContactType["MEMBER"] = "MEMBER";
    ContactType["NOT_AUTHENTICATED_MEMBER"] = "NOT_AUTHENTICATED_MEMBER";
})(ContactType = exports.ContactType || (exports.ContactType = {}));
var ContactsFacetType;
(function (ContactsFacetType) {
    ContactsFacetType["UNKNOWN"] = "UNKNOWN";
    ContactsFacetType["ALL_CONTACTS"] = "ALL_CONTACTS";
    ContactsFacetType["LABEL"] = "LABEL";
    ContactsFacetType["SUBSCRIPTION_STATUS"] = "SUBSCRIPTION_STATUS";
})(ContactsFacetType = exports.ContactsFacetType || (exports.ContactsFacetType = {}));
var EmailEmailTag;
(function (EmailEmailTag) {
    EmailEmailTag["UNTAGGED"] = "UNTAGGED";
    EmailEmailTag["MAIN"] = "MAIN";
    EmailEmailTag["HOME"] = "HOME";
    EmailEmailTag["WORK"] = "WORK";
    EmailEmailTag["OTHER"] = "OTHER";
})(EmailEmailTag = exports.EmailEmailTag || (exports.EmailEmailTag = {}));
var EventType;
(function (EventType) {
    EventType["UNKNOWN"] = "UNKNOWN";
    EventType["CREATED"] = "CREATED";
    EventType["UPDATED"] = "UPDATED";
    EventType["DELETED"] = "DELETED";
    EventType["ACTION"] = "ACTION";
})(EventType = exports.EventType || (exports.EventType = {}));
var Exposure;
(function (Exposure) {
    Exposure["PRIVATE"] = "PRIVATE";
    Exposure["INTERNAL"] = "INTERNAL";
    Exposure["PUBLIC"] = "PUBLIC";
})(Exposure = exports.Exposure || (exports.Exposure = {}));
var Format;
(function (Format) {
    Format["EMAIL"] = "EMAIL";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["IPV4"] = "IPV4";
    Format["IPV6"] = "IPV6";
    Format["URI"] = "URI";
    Format["WEB_URL"] = "WEB_URL";
    Format["PHONE"] = "PHONE";
    Format["CREDIT_CARD"] = "CREDIT_CARD";
    Format["GUID"] = "GUID";
    Format["COUNTRY"] = "COUNTRY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DECIMAL_VALUE"] = "DECIMAL_VALUE";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE_TAG"] = "LANGUAGE_TAG";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["LOCAL_DATE"] = "LOCAL_DATE";
    Format["LOCAL_TIME"] = "LOCAL_TIME";
    Format["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
})(Format = exports.Format || (exports.Format = {}));
var GetContactResponseType;
(function (GetContactResponseType) {
    GetContactResponseType["REGULAR"] = "REGULAR";
    GetContactResponseType["IMPLICIT"] = "IMPLICIT";
    GetContactResponseType["MERGED"] = "MERGED";
})(GetContactResponseType = exports.GetContactResponseType || (exports.GetContactResponseType = {}));
var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode["OK"] = "OK";
    HttpStatusCode["UNAUTHENTICATED"] = "UNAUTHENTICATED";
    HttpStatusCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    HttpStatusCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    HttpStatusCode["NOT_FOUND"] = "NOT_FOUND";
    HttpStatusCode["INTERNAL"] = "INTERNAL";
    HttpStatusCode["UNAVAILABLE"] = "UNAVAILABLE";
    HttpStatusCode["RESOURCE_EXHAUSTED"] = "RESOURCE_EXHAUSTED";
    HttpStatusCode["CANCELED"] = "CANCELED";
    HttpStatusCode["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    HttpStatusCode["FAILED_PRECONDITION"] = "FAILED_PRECONDITION";
})(HttpStatusCode = exports.HttpStatusCode || (exports.HttpStatusCode = {}));
var IdempotencyLevel;
(function (IdempotencyLevel) {
    IdempotencyLevel["IDEMPOTENCY_UNKNOWN"] = "IDEMPOTENCY_UNKNOWN";
    IdempotencyLevel["NO_SIDE_EFFECTS"] = "NO_SIDE_EFFECTS";
    IdempotencyLevel["IDEMPOTENT"] = "IDEMPOTENT";
})(IdempotencyLevel = exports.IdempotencyLevel || (exports.IdempotencyLevel = {}));
var JSType;
(function (JSType) {
    JSType["JS_NORMAL"] = "JS_NORMAL";
    JSType["JS_STRING"] = "JS_STRING";
    JSType["JS_NUMBER"] = "JS_NUMBER";
})(JSType = exports.JSType || (exports.JSType = {}));
var Label;
(function (Label) {
    Label["LABEL_OPTIONAL"] = "LABEL_OPTIONAL";
    Label["LABEL_REQUIRED"] = "LABEL_REQUIRED";
    Label["LABEL_REPEATED"] = "LABEL_REPEATED";
})(Label = exports.Label || (exports.Label = {}));
var Maturity;
(function (Maturity) {
    Maturity["ALPHA"] = "ALPHA";
    Maturity["BETA"] = "BETA";
    Maturity["IA"] = "IA";
    Maturity["GA"] = "GA";
})(Maturity = exports.Maturity || (exports.Maturity = {}));
var NullValue;
(function (NullValue) {
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue = exports.NullValue || (exports.NullValue = {}));
var OptimizeMode;
(function (OptimizeMode) {
    OptimizeMode["SPEED"] = "SPEED";
    OptimizeMode["CODE_SIZE"] = "CODE_SIZE";
    OptimizeMode["LITE_RUNTIME"] = "LITE_RUNTIME";
})(OptimizeMode = exports.OptimizeMode || (exports.OptimizeMode = {}));
var PhonePhoneTag;
(function (PhonePhoneTag) {
    PhonePhoneTag["UNTAGGED"] = "UNTAGGED";
    PhonePhoneTag["MAIN"] = "MAIN";
    PhonePhoneTag["HOME"] = "HOME";
    PhonePhoneTag["MOBILE"] = "MOBILE";
    PhonePhoneTag["WORK"] = "WORK";
    PhonePhoneTag["FAX"] = "FAX";
    PhonePhoneTag["OTHER"] = "OTHER";
})(PhonePhoneTag = exports.PhonePhoneTag || (exports.PhonePhoneTag = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var SourceType;
(function (SourceType) {
    SourceType["OTHER"] = "OTHER";
    SourceType["IMPORT"] = "IMPORT";
    SourceType["APP"] = "APP";
    SourceType["SITE_MEMBERS"] = "SITE_MEMBERS";
    SourceType["MANUAL"] = "MANUAL";
})(SourceType = exports.SourceType || (exports.SourceType = {}));
var SubmitOperation;
(function (SubmitOperation) {
    SubmitOperation["UNKNOWN"] = "UNKNOWN";
    SubmitOperation["CREATE"] = "CREATE";
    SubmitOperation["UPDATE"] = "UPDATE";
})(SubmitOperation = exports.SubmitOperation || (exports.SubmitOperation = {}));
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    TaskStatus["NEW"] = "NEW";
    TaskStatus["LOADING"] = "LOADING";
    TaskStatus["RUNNING"] = "RUNNING";
    TaskStatus["COMPLETED"] = "COMPLETED";
    TaskStatus["FAILED"] = "FAILED";
})(TaskStatus = exports.TaskStatus || (exports.TaskStatus = {}));
var TaskType;
(function (TaskType) {
    TaskType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    TaskType["DELETE"] = "DELETE";
    TaskType["UPDATE"] = "UPDATE";
    TaskType["ADD_LABELS"] = "ADD_LABELS";
    TaskType["REMOVE_LABELS"] = "REMOVE_LABELS";
})(TaskType = exports.TaskType || (exports.TaskType = {}));
var Type;
(function (Type) {
    Type["TYPE_DOUBLE"] = "TYPE_DOUBLE";
    Type["TYPE_FLOAT"] = "TYPE_FLOAT";
    Type["TYPE_INT64"] = "TYPE_INT64";
    Type["TYPE_UINT64"] = "TYPE_UINT64";
    Type["TYPE_INT32"] = "TYPE_INT32";
    Type["TYPE_FIXED64"] = "TYPE_FIXED64";
    Type["TYPE_FIXED32"] = "TYPE_FIXED32";
    Type["TYPE_BOOL"] = "TYPE_BOOL";
    Type["TYPE_STRING"] = "TYPE_STRING";
    Type["TYPE_GROUP"] = "TYPE_GROUP";
    Type["TYPE_MESSAGE"] = "TYPE_MESSAGE";
    Type["TYPE_BYTES"] = "TYPE_BYTES";
    Type["TYPE_UINT32"] = "TYPE_UINT32";
    Type["TYPE_ENUM"] = "TYPE_ENUM";
    Type["TYPE_SFIXED32"] = "TYPE_SFIXED32";
    Type["TYPE_SFIXED64"] = "TYPE_SFIXED64";
    Type["TYPE_SINT32"] = "TYPE_SINT32";
    Type["TYPE_SINT64"] = "TYPE_SINT64";
})(Type = exports.Type || (exports.Type = {}));
var VatType;
(function (VatType) {
    VatType["UNSPECIFIED"] = "UNSPECIFIED";
    VatType["CPF"] = "CPF";
    VatType["CNPJ"] = "CNPJ";
})(VatType = exports.VatType || (exports.VatType = {}));
